'use client';

import useProduct from '@/contexts/ProductProvider';
import GenericsModal from '../GenericsModal';

const WrapperGenericsModal = ({ data }) => {
	const { showGenericModel, setShowGenericModel } = useProduct();

	return <GenericsModal data={data} open={showGenericModel} setShowGenericsModal={setShowGenericModel} />;
};

export default WrapperGenericsModal;
